import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'md:group-hover/tile:bg-bg-page flex h-[50px] cursor-pointer items-center justify-between gap-4 rounded-full md:pl-4',
    title: 'md:heading-s-bold heading-xs-bold -mt-1',
    button:
      'relative flex size-[50px] p-0 transition-opacity group-hover/tile:opacity-100 md:opacity-0'
  }
});
